import { Module } from "wrapper6";

export default class ItemWall extends Module {
    ready() {

        const WIDGETS = document.querySelectorAll('.mtt-item-wall');

        if (WIDGETS.length) {
            for (let i = 0; i < WIDGETS.length; i++) {
                new ItemWallClass(WIDGETS[i]);
            }
        }
    }
}

class ItemWallClass {

    constructor(container) {

        this.CONTAINER = container;
        this.ITEMS = this.CONTAINER.querySelectorAll('.mtt-item-wall-item');

        this.loadmoreHandler();
    }

    loadmoreHandler() {
        const LOADMORE = this.CONTAINER.querySelector('.mtt-item-wall__loadmore');
        if (!LOADMORE || this.ITEMS.length == 0) return;
        
        LOADMORE.addEventListener('click', (e) => {

            // hide loadmore button
            LOADMORE.classList.add('mtt-item-wall__loadmore--hide');

            // remove hide class
            for (let i = 0; i < this.ITEMS.length; i++) {
                this.ITEMS[i].classList.remove('mtt-item-wall-item--hide');
            }
        });
    }
}